export const isLocalStorageAvailable = () => {
  const test = 'test'
  try {
    localStorage.setItem(test, test)
    localStorage.removeItem(test)
    return true
  } catch (e) {
    return false
  }
}

export const setUserInfoLocalStorage = (userInfo) => {
  try {
    Object.assign(userInfo, { createdAt: new Date() })

    const userInfoParsed = JSON.stringify(userInfo)
    localStorage.setItem('userInformation', userInfoParsed)
  } catch (e) {
    console.log('error', e)
  }
}

export const getUserInfoLocalStorage = () => {
  try {
    const userInformation = localStorage.getItem('userInformation')

    if (!userInformation) return {}

    const userObject = JSON.parse(userInformation)
    const { createdAt, ...userInfo } = userObject

    const dateParsed = Date.parse(createdAt)
    const now = new Date()
    const diff = Math.abs(now - dateParsed) / (1000 * 60 * 60 * 24)
    return diff < 30 ? userInfo : {}
  } catch (error) {
    return {}
  }
}

export const savePaymentMethodsLocalStorage = (paymentMethods, pinflagApiKey) => {
  try {
    const paymentMethodsObject = { [pinflagApiKey]: { paymentMethods, createdAt: new Date() } }

    localStorage.setItem('paymentMethods', JSON.stringify(paymentMethodsObject))
  } catch (e) {
    console.log('error', e)
  }
}

export const getPaymentMethodsLocalStorage = (pinflagApiKey) => {
  try {
    const localPaymentMethods = localStorage.getItem('paymentMethods')

    if (!localPaymentMethods) return null

    const paymentMethodsObject = JSON.parse(localPaymentMethods)

    if (!paymentMethodsObject[pinflagApiKey]) return null

    const { createdAt, paymentMethods } = paymentMethodsObject[pinflagApiKey]

    const dateParsed = Date.parse(createdAt)
    const now = new Date()
    const diff = Math.abs(now - dateParsed) / (1000 * 60 * 60)

    return diff < 12 ? paymentMethods : null
  } catch (error) {
    return null
  }
}

export const saveConfigurationsLocalStorage = (configurations, pinflagApiKey) => {
  try {
    const configurationsObject = { [pinflagApiKey]: { configurations, createdAt: new Date() } }

    localStorage.setItem('configurations', JSON.stringify(configurationsObject))
  } catch (e) {
    console.log('error', e)
  }
}

export const getConfigurationsLocalStorage = (pinflagApiKey) => {
  try {
    const localConfigurations = localStorage.getItem('configurations')

    if (!localConfigurations) return null

    const configurationsObject = JSON.parse(localConfigurations)

    if (!configurationsObject[pinflagApiKey]) return null
    const { createdAt, configurations } = configurationsObject[pinflagApiKey]

    const dateParsed = Date.parse(createdAt)
    const now = new Date()
    const diff = Math.abs(now - dateParsed) / (1000 * 60)

    return diff < 5 ? configurations : null
  } catch (error) {
    return null
  }
}

export const getLoaderInfoLocalStorage = (pinflagApiKey) => {
  try {
    const loaderInfo = localStorage.getItem('loaderInfo')

    if (!loaderInfo) return null

    const loaderInfoObject = JSON.parse(loaderInfo)

    if (!loaderInfoObject[pinflagApiKey]) return null

    const { createdAt, loaderInfoParsed } = loaderInfoObject[pinflagApiKey]

    const dateParsed = Date.parse(createdAt)
    const now = new Date()
    const days = Math.abs(now - dateParsed) / (1000 * 60 * 60 * 24)

    return days < 1 ? loaderInfoParsed : null
  } catch (error) {
    return null
  }
}

export const setLoaderInfoLocalStorage = (loaderInfo, pinflagApiKey) => {
  try {
    const loaderInfoObject = { [pinflagApiKey]: { loaderInfoParsed: loaderInfo, createdAt: new Date() } }

    localStorage.setItem('loaderInfo', JSON.stringify(loaderInfoObject))
  } catch (e) {
    console.log('error', e)
  }
}

export const setPaymentStateLocalStorage = (paymentState, pinflagApiKey) => {
  try {
    const paymentStateInformation = localStorage.getItem('paymentState')
    const paymentStateObject = JSON.parse(paymentStateInformation) || {}

    paymentStateObject[pinflagApiKey] = { paymentState, createdAt: new Date() }

    localStorage.setItem('paymentState', JSON.stringify(paymentStateObject))
  } catch (e) {
    console.log('error', e)
  }
}

export const getPaymentStateLocalStorage = (pinflagApiKey) => {
  try {
    const paymentStateInformation = localStorage.getItem('paymentState')

    if (!paymentStateInformation) return null

    const paymentStateObject = JSON.parse(paymentStateInformation)

    if (!paymentStateObject[pinflagApiKey]) return null

    const { createdAt, paymentState } = paymentStateObject[pinflagApiKey]

    const dateParsed = Date.parse(createdAt)
    const now = new Date()
    const diff = Math.abs(now - dateParsed) / (1000 * 60 * 60)

    return diff < 12 ? paymentState : null
  } catch (error) {
    return null
  }
}

export const removePaymentStateLocalStorage = (pinflagApiKey) => {
  try {
    const paymentStateInformation = localStorage.getItem('paymentState')
    const paymentStateObject = JSON.parse(paymentStateInformation)

    delete paymentStateObject[pinflagApiKey]

    localStorage.setItem('paymentState', JSON.stringify(paymentStateObject))
  } catch (e) {
    console.log('error', e)
  }
}

export const setDataContextLocalStorage = (dataContext, pinflagApiKey) => {
  try {
    const dataContextInformation = localStorage.getItem('dataContext')
    const dataContextObject = JSON.parse(dataContextInformation) || {}

    dataContextObject[pinflagApiKey] = { dataContext, createdAt: new Date() }

    localStorage.setItem('dataContext', JSON.stringify(dataContextObject))
  } catch (e) {
    console.log('error', e)
  }
}

export const getDataContextLocalStorage = (pinflagApiKey) => {
  try {
    const dataContextInformation = localStorage.getItem('dataContext')

    if (!dataContextInformation) return null

    const dataContextObject = JSON.parse(dataContextInformation)

    if (!dataContextObject[pinflagApiKey]) return null

    const { createdAt, dataContext } = dataContextObject[pinflagApiKey]

    const dateParsed = Date.parse(createdAt)
    const now = new Date()
    const diff = Math.abs(now - dateParsed) / (1000 * 60 * 60)

    return diff < 12 ? dataContext : null
  } catch (error) {
    return null
  }
}

export const removeDataContextLocalStorage = (pinflagApiKey) => {
  try {
    const dataContextInformation = localStorage.getItem('dataContext')
    const dataContextObject = JSON.parse(dataContextInformation)

    delete dataContextObject[pinflagApiKey]

    localStorage.setItem('dataContext', JSON.stringify(dataContextObject))
  } catch (e) {
    console.log('error', e)
  }
}

export const setGetnetTypeOfFlowLocalStorage = (typeOfFlow) => {
  try {
    localStorage.setItem('getnetTypeOfFlow', typeOfFlow)
  } catch (e) {
    console.log('error', e)
  }
}

export const getGetnetTypeOfFlowLocalStorage = () => {
  try {
    return localStorage.getItem('getnetTypeOfFlow')
  } catch (e) {
    console.log('error', e)
  }
}

export const saveScraperAssignmentLocalStorage = (assignment, pinflagApiKey) => {
  try {
    localStorage.setItem('scraperAssignment', JSON.stringify({ [pinflagApiKey]: assignment }))
  } catch (e) {
    console.log('error', e)
  }
}

export const loadState = () => {
  try {
    const raw = localStorage.getItem('pinflag_session_v1')
    if (!raw) return null
    return JSON.parse(raw)
  } catch (e) {
    console.warn('pf_session: error reading storage', e)
    return null
  }
}

export const saveState = (state) => {
  try {
    localStorage.setItem('pinflag_session_v1', JSON.stringify(state))
  } catch (e) {
    console.warn('pf_session: error saving storage', e)
  }
}

const REDIRECT_TYPE_TTL_MINUTES = 30

export const setRedirectTypeLocalStorage = (redirectType) => {
  try {
    localStorage.setItem('redirectType', JSON.stringify({ redirectType, createdAt: new Date() }))
  } catch (e) {
    console.log('error', e)
  }
}

export const getRedirectTypeLocalStorage = () => {
  try {
    const stored = localStorage.getItem('redirectType')

    if (!stored) return null

    const { redirectType, createdAt } = JSON.parse(stored)

    const dateParsed = Date.parse(createdAt)
    const now = new Date()
    const diff = Math.abs(now - dateParsed) / (1000 * 60)

    return diff < REDIRECT_TYPE_TTL_MINUTES ? redirectType : null
  } catch (e) {
    console.log('error', e)
    return null
  }
}

export const removeRedirectTypeLocalStorage = () => {
  try {
    localStorage.removeItem('redirectType')
  } catch (e) {
    console.log('error', e)
  }
}
